import { SignStatusEnums } from "app/services/api/types/medications/enums/SignStatusEnums";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import StatusIndicator from "ui/atoms/avatar/statusIndicator/StatusIndicator";
import { StatusIndicatorType } from "ui/atoms/avatar/statusIndicator/interfaces";

export const MedicationStatusMapping: Record<
  string,
  { status: StatusIndicatorType; title: string }
> = {
  [SignStatusEnums.PENDING_SIGNATURE]: {
    status: "warning",
    title: "Pending Sign-Off",
  },
  [SignStatusEnums.SIGNED]: {
    status: "active",
    title: "Signed-Off",
  },
  past_end_date: {
    status: "danger",
    title: "Past End Date",
  },
};

interface Props {
  medication: MedicationModel;
}
export function MedicationStatusIndicator({ medication }: Props) {
  const status =
    MedicationStatusMapping[
      medication.is_past_end_date ? "past_end_date" : medication.sign_status
    ];

  if (!medication || !status) {
    return null;
  }

  return <StatusIndicator status={status.status} statusTitle={status.title} />;
}
